var $07ada6ae0946b717$exports = {};
$07ada6ae0946b717$exports = {
    "colorFormat": `Formato en color`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$07ada6ae0946b717$exports as default};
//# sourceMappingURL=es-ES.mjs.map
